module.exports = __webpack_public_path__ + "images/emoji/clock2.2885d7dfcc187fb926d8.png";